import React from "react"
import { useDispatch, useSelector } from "react-redux";
import {
    Modal
} from "reactstrap"
import { resetModal } from "../../../store/actions/modalActions";

const FullScreenModal = props => {

    const dispatch = useDispatch();
    const { isOpen, child } = useSelector((state) => state.modal);

    const closeModal = () => {
        dispatch(resetModal())
    }

    return (
        <React.Fragment>
            <Modal
                size="xl"
                isOpen={isOpen}
                className="modal-fullscreen"
            >
                <div className="modal-header">
                    <div className="close">
                        <i className="fas fa-times" onClick={closeModal}></i>
                    </div>
                </div>
                <div dir={props.dir} className={"modal-body " + props.dir}>
                    {child}
                </div>
            </Modal>
        </React.Fragment>
    )

}

export default FullScreenModal
